import { useContext } from 'react';

import { ContentContainerContext } from '../ContentContainerContextProvider';

export const useContentContainerContext = () => useContext(ContentContainerContext);
